import React from 'react';
import { Languages } from 'lucide-react';

export const AI_LANGUAGE_OPTIONS = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'hi', label: 'Hindi', nativeLabel: 'हिन्दी' },
  { code: 'kn', label: 'Kannada', nativeLabel: 'ಕನ್ನಡ' },
  { code: 'te', label: 'Telugu', nativeLabel: 'తెలుగు' },
  { code: 'ta', label: 'Tamil', nativeLabel: 'தமிழ்' },
  { code: 'mr', label: 'Marathi', nativeLabel: 'मराठी' },
  { code: 'bn', label: 'Bengali', nativeLabel: 'বাংলা' },
  { code: 'ml', label: 'Malayalam', nativeLabel: 'മലയാളം' },
  { code: 'pa', label: 'Punjabi', nativeLabel: 'ਪੰਜਾਬੀ' },
  { code: 'gu', label: 'Gujarati', nativeLabel: 'ગુજરાતી' }
];

export function languageDisplay(code) {
  const row = AI_LANGUAGE_OPTIONS.find((l) => l.code === code);
  return row ? `${row.label} (${row.nativeLabel})` : code;
}

export default function AiLanguageSelect({
  value,
  onChange,
  disabled = false,
  className = '',
  label = 'Translate to',
  languages = AI_LANGUAGE_OPTIONS
}) {
  const options = languages?.length ? languages : AI_LANGUAGE_OPTIONS;

  return (
    <div className={className}>
      <label className="mb-2 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-gray-500">
        <Languages className="h-3.5 w-3.5" />
        {label}
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm disabled:bg-gray-50">
        {options.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.label} — {lang.nativeLabel}
          </option>
        ))}
      </select>
    </div>
  );
}
